/*
* Copyright (c) 2009-2022. Authors: see NOTICE file.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

import _ from 'lodash';

/**
 * Return a Regexp based on the provided search string, and using * as a wildcard character.
 * @param {String} str The string entered by the user
 * @return {RegExp}
 */
export function getWildcardRegexp(str) {
  let escapedString = _.escapeRegExp(str); // escape all RegExp special characters (only * should have a special behaviour)
  return new RegExp('(' + escapedString.split('\\*').join('.*') + ')', 'i');
}

export function truncate(str, max = 100) {
  if (!str) return str;
  return str.length > max
    ? str.slice(0, max) + '...'
    : str;
}

export function wrapSmart(text, maxChars) {
  if (!text) {
    return '';
  }

  return text.split('\n').map(line => {
    const words = line.split(' ');
    let current = '';
    const out = [];

    for (let word of words) {
      while (word.length > maxChars) {
        out.push(word.slice(0, maxChars));
        word = word.slice(maxChars);
      }

      if ((current + word).length > maxChars) {
        out.push(current.trim());
        current = '';
      }

      current += word + ' ';
    }

    if (current) out.push(current.trim());

    return out.join('\n');
  }).join('\n');
}
